import {
  ApplicationConfig,
  importProvidersFrom,
  LOCALE_ID,
  provideZoneChangeDetection,
} from '@angular/core';
import { provideRouter, withViewTransitions } from '@angular/router';
import { appRoutes } from './app.routes';
import {
  BrowserModule,
  provideClientHydration,
  withHttpTransferCacheOptions,
} from '@angular/platform-browser';
import {
  BrowserAnimationsModule,
  provideAnimations,
} from '@angular/platform-browser/animations';
import {
  provideHttpClient,
  withFetch,
  withInterceptors,
} from '@angular/common/http';
import { provideToastr } from 'ngx-toastr';
import { registerLocaleData } from '@angular/common';
import localeKo from '@angular/common/locales/ko';
import { HttpInterceptor } from '../libs/http-interceptor';
import { provideComponentConfig } from '@client';
import { ApiModule } from '@api-client';
import { environment } from '../environments/environment';
import { provideMarkdown } from 'ngx-markdown';
import { register } from 'swiper/element/bundle';

register();

registerLocaleData(localeKo);

export const appConfig: ApplicationConfig = {
  providers: [
    provideClientHydration(
      withHttpTransferCacheOptions({
        includePostRequests: false,
        filter: (req) => false,
      }),
    ),
    provideZoneChangeDetection({ eventCoalescing: true }),
    provideRouter(appRoutes, withViewTransitions()),
    provideAnimations(),
    provideHttpClient(withFetch(), withInterceptors([HttpInterceptor])),
    provideToastr(),
    provideMarkdown(),
    importProvidersFrom(
      BrowserModule,
      BrowserAnimationsModule,
      ApiModule.forRoot({
        rootUrl: environment.baseUrl,
      }),
    ),
    { provide: LOCALE_ID, useValue: 'ko' },

    // 기본 컴포넌트 스타일 설정
    provideComponentConfig({
      badge: {
        size: 'sm',
      },
      button: {
        size: 'sm',
      },
      input: {
        size: 'md',
        rounded: 'sm',
      },
      label: {},
    }),
  ],
};
